import { render, staticRenderFns } from "./LabSideInstall.vue?vue&type=template&id=844edeb4&scoped=true&"
import script from "./LabSideInstall.vue?vue&type=script&lang=js&"
export * from "./LabSideInstall.vue?vue&type=script&lang=js&"
import style0 from "./LabSideInstall.vue?vue&type=style&index=0&id=844edeb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844edeb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VIcon,VNavigationDrawer,VRow})
